export function isObjectEmptyOrNull(obj) {
  return Object.values(obj).every(
    (value) => value === null || (Array.isArray(value) && value.length === 0)
  );
}
